import { createSelector } from 'reselect'
import { State } from 'index'

const loadingSelector = (state: State) => state.loading

export const getLoadingState = createSelector([loadingSelector], (state) => state.state)
